import { render, staticRenderFns } from "./LoanCollateralAssetGuaranteesFieldsEdit.vue?vue&type=template&id=4e8fd6d4&scoped=true&lang=pug&"
import script from "./LoanCollateralAssetGuaranteesFieldsEdit.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAssetGuaranteesFieldsEdit.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAssetGuaranteesFieldsEdit.vue?vue&type=style&index=0&id=4e8fd6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8fd6d4",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAssetGuaranteesFieldsEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports